type Owner = {
  name?: string;
  email?: string;
};

type ReviewDetailsProps = {
  owner1: Owner;
  owner2: Owner;
  youOwner: 1 | 2; // owner 1 creator or owner 2 invitee
  publicKey: string;
};

const MailIcon = () => (
  <svg
    style={{ marginRight: ".5rem" }}
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.75"
    strokeLinecap="round"
    strokeLinejoin="round"
    name="mail"
  >
    <rect x="2" y="4" width="20" height="16" rx="2"></rect>
    <path d="m22 6-10 7L2 6"></path>
  </svg>
);

const OwnerRow = ({ owner, isYou }: { owner: Owner; isYou: boolean }) => {
  const displayName = owner.name || owner.email || (isYou ? "You" : "—");
  const displayEmail = owner.email || (isYou ? "" : "—");
  return (
    <div className="MultisigReview__person">
      <span>{displayName}</span>
      <span className="MultisigReview__mail">
        <MailIcon />
        {displayEmail}
      </span>
    </div>
  );
};

export const ReviewDetails = ({ owner1, owner2, youOwner, publicKey }: ReviewDetailsProps) => {
  const truncated =
    publicKey.length > 12 ? `${publicKey.slice(0, 6)}...${publicKey.slice(-4)}` : publicKey;

  return (
    <div className="MultisigReview">
      <div className="MultisigReview__group">
        <h3 className="MultisigReview__subheading">
          Owner 1 {youOwner === 1 && <span>(you)</span>}
        </h3>
        <OwnerRow owner={owner1} isYou={youOwner === 1} />
      </div>
      <div className="MultisigReview__group">
        <h3 className="MultisigReview__subheading">
          Owner 2 {youOwner === 2 && <span>(you)</span>}
        </h3>
        <OwnerRow owner={owner2} isYou={youOwner === 2} />
      </div>
      <div className="MultisigReview__group">
        <h3 className="MultisigReview__subheading">Your co-signing key</h3>
        <div className="MultisigReview__person">
          <span>Disbursement signing key</span>
          <code className="MultisigConnect__code" title={publicKey}>
            {truncated || "—"}
          </code>
        </div>
      </div>
    </div>
  );
};
